import { type ReactNode, useEffect, useState, useMemo } from "react";
import { Link, useRouterState } from "@tanstack/react-router";

const allSections = [
  { id: "overview", label: "Übersicht" },
  { id: "rooms", label: "Räume & Flächen" },
  { id: "hotel", label: "Hotel & Übernachtung" },
  { id: "details", label: "Detaildaten" },
  { id: "downloads", label: "Downloads" },
];

export const SectionNav = ({
  showRooms = false,
  showHotel = false,
  showDownloads = false,
  actionButtons,
}: {
  showRooms?: boolean;
  showHotel?: boolean;
  showDownloads?: boolean;
  /** Optional action buttons shown on the right (e.g. Anfragen, Merken, Teilen) when sidebar is scrolled out */
  actionButtons?: ReactNode;
}) => {
  const [active, setActive] = useState(allSections[0].id);
  const { location } = useRouterState();

  const sections = useMemo(() => {
    return allSections.filter((s) => {
      if (s.id === "rooms" && !showRooms) return false;
      if (s.id === "hotel" && !showHotel) return false;
      if (s.id === "downloads" && !showDownloads) return false;
      return true;
    });
  }, [showRooms, showHotel, showDownloads]);

  useEffect(() => {
    const currentHash = location.hash?.replace("#", "");
    const validHash = sections.some((s) => s.id === currentHash)
      ? currentHash
      : sections[0]?.id;
    setActive(validHash || allSections[0].id);
  }, [location.hash, sections]);

  return (
    <div className="sticky top-0 bg-white z-40 border-b-4 layout-place-full-width layout-content-grid">
      <div className="flex items-center justify-between gap-4 translate-y-[3px] -mt-px">
        <div className="flex gap-8 relative overflow-x-auto scrollbar-hide scroll-smooth flex-nowrap min-w-0">
          {sections.map((s) => (
            <Link
              to={location.pathname}
              hash={s.id}
              key={s.id}
              className={"relative group whitespace-nowrap pt-2.5 pb-4"}
            >
              {s.label}
              {active === s.id && (
                <span className="absolute bottom-0 left-0 w-full h-[5px] bg-dove-gray-dark rounded-full"></span>
              )}

              {active !== s.id && (
                <span className="absolute bottom-0 left-0 w-full h-[5px] bg-dove-gray-dark rounded-full scale-x-0 group-hover:scale-x-100 transition-transform"></span>
              )}
            </Link>
          ))}
        </div>
        {actionButtons ? (
          <div className="shrink-0 flex items-center -translate-y-[3px]">
            {actionButtons}
          </div>
        ) : null}
      </div>
    </div>
  );
};
